<div ngbDropdownMenu>
  <div class="items-list">
  <ul
    class="txui-menu txui-widget txui-widget-content txui-corner-all"
    role="menu"
>
    <ng-container *ngIf="showAttorneys">
      <!-- Show grouping header when we also show staff -->
      <li class="txui-menu-item" role="presentation" *ngIf="showStaff">
        <a class="txui-corner-all" tabindex="-1" role="menuitem">
          <div class="menu-item-category-header">
            <h1>Attorneys</h1>
          </div>
        </a>
      </li>
      <li class="txui-menu-item-small txui-menu-item" role="presentation" *ngFor="let person of attorneys$ | async">
        <a class="txui-corner-all" ngbDropdownItem role="menuitem" (click)="itemClick(person.staID)">
          <div class="small-menu-item-caption-container">
            <p>{{ person.name }}</p>
          </div>
        </a>
      </li>
      <li class="txui-menu-item-small txui-menu-item" role="presentation" *ngIf="!(attorneys$ | async)?.length">
        <div class="p-2 fst-italic">No Attorneys found</div>
      </li>
    </ng-container>
    <ng-container *ngIf="showStaff">
      <!-- Show grouping header when we also show attorneys -->
      <li class="txui-menu-item" role="presentation" *ngIf="showAttorneys">
        <a class="txui-corner-all" tabindex="-1" role="menuitem">
          <div class="menu-item-category-header">
            <h1>Staff</h1>
          </div>
        </a>
      </li>
      <li class="txui-menu-item-small txui-menu-item" role="presentation" *ngFor="let person of staff$ | async">
        <a class="txui-corner-all" ngbDropdownItem role="menuitem" (click)="itemClick(person.staID)">
          <div class="small-menu-item-caption-container">
            <p>{{ person.name }}</p>
          </div>
        </a>
      </li>
      <li class="txui-menu-item-small txui-menu-item" role="presentation" *ngIf="!(staff$ | async)?.length">
        <div class="p-2 fst-italic">No Staff found</div>
      </li>
    </ng-container>
  </ul>
</div></div>